module.exports = __webpack_public_path__ + "static/media/family_03.a37104be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_03.jpg
// module id = 5835
// module chunks = 0